import { ValidationErrorResponse } from "../../../services/ValidationError";

export interface FormValue {
  wasTouched: boolean;
  isValid: boolean | undefined;
}

export interface TextFormValue extends FormValue {
  value: string;
}

export interface DateFormValue extends FormValue {
  value: Date | undefined;
}

export interface FileFormValue extends FormValue {
  value: File | undefined;
}

export interface BooleanFormValue extends FormValue {
  value: boolean;
}

export interface FormState {
  primerNombre: TextFormValue;
  segundoNombre: TextFormValue;
  primerApellido: TextFormValue;
  segundoApellido: TextFormValue;
  contrato: FileFormValue;
  firma: TextFormValue;
  tipoDocumento: TextFormValue;
  documento: TextFormValue;
  ciudadExpedicion: TextFormValue;
  email: TextFormValue;
  celular: TextFormValue;
  nombresContactoAlterno: TextFormValue;
  celularContactoAlterno: TextFormValue;
  direccionResidencia: TextFormValue;
  sectorResidencia: TextFormValue;
  canalMarketing: TextFormValue;
  esTurista: BooleanFormValue;
  paisProveniencia: TextFormValue;
  ciudadProveniencia: TextFormValue;
  fechaNacimiento: DateFormValue;
}

export const initialFormState: FormState = {
  primerNombre: { value: "", wasTouched: false, isValid: undefined },
  segundoNombre: { value: "", wasTouched: false, isValid: undefined },
  primerApellido: { value: "", wasTouched: false, isValid: undefined },
  segundoApellido: { value: "", wasTouched: false, isValid: undefined },
  contrato: { value: undefined, wasTouched: false, isValid: undefined },
  firma: { value: "", wasTouched: false, isValid: undefined },
  tipoDocumento: { value: "", wasTouched: false, isValid: undefined },
  documento: { value: "", wasTouched: false, isValid: undefined },
  ciudadExpedicion: { value: "", wasTouched: false, isValid: undefined },
  email: { value: "", wasTouched: false, isValid: undefined },
  celular: { value: "", wasTouched: false, isValid: undefined },
  nombresContactoAlterno: { value: "", wasTouched: false, isValid: undefined },
  celularContactoAlterno: { value: "", wasTouched: false, isValid: undefined },
  direccionResidencia: { value: "", wasTouched: false, isValid: undefined },
  sectorResidencia: { value: "", wasTouched: false, isValid: undefined },
  canalMarketing: { value: "", wasTouched: false, isValid: undefined },
  esTurista: { value: false, wasTouched: false, isValid: undefined },
  paisProveniencia: { value: "", wasTouched: false, isValid: undefined },
  ciudadProveniencia: { value: "", wasTouched: false, isValid: undefined },
  fechaNacimiento: { value: undefined, wasTouched: false, isValid: undefined },
};

export const resetValidStates = (formState: FormState) => {
  Object.keys(formState).forEach((_key) => {
    const currentVal: FormValue = (formState as any)[_key] as FormValue;
    (formState as any)[_key] = { ...currentVal, isValid: undefined };
  });
};

export const invalidateStates = (
  formState: FormState,
  validationErrorResponse: ValidationErrorResponse
) => {
  Object.keys(validationErrorResponse).forEach((errKey) => {
    const errKeyStr = errKey as string;
    const currentVal: FormValue = (formState as any)[errKeyStr] as FormValue;
    (formState as any)[errKeyStr] = { ...currentVal, isValid: false };
  });
};
